import { AuthorModel, UserModel } from "@api/models";
import { LOG_EVENT_DETAILS, makeClickLogDataAttrs } from "@lib/analyticLog";
import { GLOBALS } from "config";
import Link from "next/link";

export function AuthorLink({
  author,
  seriesIndexId,
  displayIndex,
  className,
  showRole,
}: {
  author: AuthorModel | UserModel;
  seriesIndexId?: number;
  className?: string;
  showRole?: boolean;
  displayIndex: number;
}) {
  const name = "name" in author ? author.name : "displayName" in author ? author.displayName : "";
  const role = "role" in author ? author.role : "";
  if (GLOBALS.HAS_AUTHOR_PAGE) {
    return (
      <Link
        href={"/authors/" + author.id}
        className={className}
        {...makeClickLogDataAttrs({
          logEventDetail: LOG_EVENT_DETAILS.categoryAuthor,
          logSeriesId: seriesIndexId,
          logPosition: "author" + (displayIndex + 1),
        })}
      >
        {showRole && role && role + "/"}
        {name}
      </Link>
    );
  } else {
    return <span>{name}</span>;
  }
}
